import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom"; // ✅ 추가
import { getDesignReviewRequests } from "../../api/design";
import BoardTable from "../../components/common/board/BoardTable";
import BoardToolbar from "../../components/common/board/BoardToolbar";
import BoardPagination from "../../components/common/board/BoardPagination";

export default function DesignReviewList() {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { id: projectId } = useParams();

  const navigate = useNavigate(); // ✅ 네비게이션 훅

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError("");
        const res = await getDesignReviewRequests({
          page,
          page_size: pageSize,
        });
        setRows(res.data.results);
        setTotal(res.data.count);
      } catch (err) {
        setError("데이터를 불러오지 못했습니다.");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [page, pageSize]);

  const columns = [
    { key: "title", header: "제목", align: "left" },
    {
      key: "category",
      header: "카테고리",
      align: "center",
      render: (r) => r.category || "-",
    },
    {
      key: "discipline",
      header: "공종",
      align: "center",
      render: (r) => r.discipline_display || "-",
    },
    {
      key: "created_by",
      header: "요청자",
      align: "center",
      render: (r) =>
        r.created_by?.last_name || r.created_by?.first_name
          ? `${r.created_by.last_name}${r.created_by.first_name}`
          : r.created_by,
    },
    {
      key: "status",
      header: "상태",
      align: "center",
      render: (r) => r.status_display,
    },
    {
      key: "created_at",
      header: "등록일",
      align: "center",
      render: (r) => new Date(r.created_at).toLocaleDateString(),
    },
  ];

  return (
    <div className="p-6">
      <h1 className="text-xl font-bold mb-4">도면 검토 요청 목록</h1>

      <BoardToolbar
        left={<div>{/* 검색/필터 자리 */}</div>}
        right={
          <button
            className="rounded-lg border px-3 py-1 text-sm"
            onClick={() => navigate(`new`)}
          >
            + 요청하기
          </button>
        }
      />

      <BoardTable
        columns={columns}
        rows={rows}
        loading={loading}
        error={error}
        emptyText="요청이 없습니다."
        onRowClick={(row) => navigate(`${row.dns}`)} // ✅ 상세 이동
      />

      <BoardPagination
        page={page}
        pageSize={pageSize}
        total={total}
        onPageChange={(p) => setPage(p)}
      />
    </div>
  );
}
